import { Component, OnInit, OnDestroy } from '@angular/core';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { Company, UserService } from 'app/shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public currentPage: any = '';

  public navigationItems: any = [
    {
      link: 'dashboard',
      title: 'NAVIGATION.navHome',
    },
    {
      link: 'favs',
      title: 'NAVIGATION.navMyPrograms',
    },
    {
      link: 'exercises',
      title: 'NAVIGATION.navAllExercises',
    },
    {
      link: 'stats',
      title: 'NAVIGATION.navStats',
    },
    {
      link: 'notification',
      title: 'NAVIGATION.navReminder',
    },
  ];

  public showNavOptions: boolean = false;

  constructor(
    private router: Router, 
    private userService: UserService,
    private translateService: TranslateService
  ) {
    router.events.takeUntil(this.ngUnsubscribe).subscribe(() => {
      this.checkCurrentPage();
    });
  }

  async getCompanyData() {
    const companyData: Company = await this.userService.getCompany();
    if (companyData.activateAchievements) {
      // Use translations for achievements menu
      this.navigationItems[3].title = 'NAVIGATION.navAchievements';
    }
  }

  ngOnInit() {
    this.checkCurrentPage();
    this.getCompanyData();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private checkCurrentPage() {
    for (const item of this.navigationItems) {
      if (this.checkRouterUrl(item.link)) {
        this.currentPage = item;
        break;
      }
    }
  }

  private checkRouterUrl(url) {
    return this.router.url.indexOf(url) !== -1;
  }

  public toggleNavOptions() {
    this.showNavOptions = !this.showNavOptions;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/components/navigation/navigation.component.ts